import React, { useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './InnerPage.css';
import './SupportPage.css';

export default function SupportPage() {
      const { t } = useLanguage();
      
      const faq = [
            {
                  q: t('supportPage.faq1Q'),
                  a: t('supportPage.faq1A'),
            },
            {
                  q: t('supportPage.faq2Q'),
                  a: t('supportPage.faq2A'),
            },
            {
                  q: t('supportPage.faq3Q'),
                  a: t('supportPage.faq3A'),
            },
            {
                  q: t('supportPage.faq4Q'),
                  a: t('supportPage.faq4A'),
            },
      ];
      
      useEffect(() => {
            window.scrollTo(0, 0);
      }, []);

      return (
            <div className="inner-page">
                  <Navbar />

                  <section className="inner-page__hero">
                        <div className="inner-page__hero-inner">
                              <div className="inner-page__tag">{t('supportPage.tag')}</div>
                              <h1 className="inner-page__title">{t('supportPage.title')}</h1>
                              <p className="inner-page__subtitle">
                                    {t('supportPage.subtitle')}
                              </p>
                        </div>
                  </section>

                  <div className="inner-page__content">

                        {/* Contact cards */}
                        <div className="support-contacts">
                              <a href="mailto:admin@agrollama.com" className="support-contact-card" id="support-email">
                                    <div className="support-contact-card__info">
                                          <span className="support-contact-card__label">{t('supportPage.emailLabel')}</span>
                                          <span className="support-contact-card__value">{t('supportPage.emailValue')}</span>
                                    </div>
                                    <svg className="support-contact-card__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                          <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                              </a>

                              <div className="support-contact-card" id="support-hours">
                                    <div className="support-contact-card__info">
                                          <span className="support-contact-card__label">{t('supportPage.assistantLabel')}</span>
                                          <span className="support-contact-card__value">{t('supportPage.assistantValue')}</span>
                                    </div>
                              </div>

                              <div className="support-contact-card" id="support-ai">
                                    <div className="support-contact-card__info">
                                          <span className="support-contact-card__label">{t('supportPage.responseLabel')}</span>
                                          <span className="support-contact-card__value">{t('supportPage.responseValue')}</span>
                                    </div>
                              </div>
                        </div>

                        {/* FAQ */}
                        <div className="content-card">
                              <h2 className="content-card__title">{t('supportPage.faqTitle')}</h2>
                              <div className="faq-list">
                                    {faq.map((item, i) => (
                                          <details className="faq-item" key={i} id={`faq-${i}`}>
                                                <summary className="faq-item__question">{item.q}</summary>
                                                <p className="faq-item__answer">{item.a}</p>
                                          </details>
                                    ))}
                              </div>
                        </div>

                        {/* Seller Support Section */}
                        <div className="content-card">
                              <h2 className="content-card__title">{t('supportPage.sellerSupportTitle')}</h2>
                              <p>{t('supportPage.sellerSupportText1')}</p>
                              <p><strong>{t('supportPage.sellerSupportText2')}</strong></p>
                        </div>

                        {/* Dispute Resolution */}
                        <div className="content-card">
                              <h2 className="content-card__title">{t('supportPage.disputeTitle')}</h2>
                              <p>{t('supportPage.disputeText')}</p>
                        </div>

                  </div>

                  <Footer />
            </div>
      );
}
